<div class="signup-container">
    <div class="right-section full-width">
        <div class="form-container">

            <div *ngIf="!registrationSuccess">
                <img src="assets/images/greenlogo.svg" alt="Delta Dental Logo" class="form-logo">
                <h2>Create an account for the Delta Dental of Missouri and South Carolina dentist credentialing portal.
                </h2>

                <form class="signup-form" [formGroup]="signupForm">
                    <div class="form-row"
                        [ngClass]="{'cnfPassword': signupForm.get('password')?.touched && signupForm.get('password')?.errors?.['minlength']}">
                        <div class="form-group">
                            <app-text-input label="Email" [replaceDoubelQuotes]="true" [for]="'email-Input'"
                                [control]="signupForm.controls['email']" [errorMessages]="errormessages">
                            </app-text-input>
                        </div>
                    </div>
                    <div class="form-row"
                        [ngClass]="{'cnfPassword': signupForm.get('password')?.touched }">
                        <div class="form-group">
                            <app-text-input label="Password" [for]="'password-Input'"
                                [type]="'password'" [control]="signupForm.controls['password']">
                            </app-text-input>
                        </div>
                        <div class="form-group">
                            <app-text-input label="Confirm password" [type]="'password'"
                                [fieldType]="'Confirm password'" [for]="'confirm Password-Input'"
                                [control]="signupForm.controls['confirmPassword']" [errorMessages]="errormessages">
                            </app-text-input>
                        </div>
                        <!-- ✅ Password Hint Added Here -->
                        <div class="password-hint" *ngIf="signupForm.get('password')?.touched">
                            <p><strong>Your password must contain:</strong></p>
                            <ul>
                                <li [class.valid]="hasMinLength()">✔ At least 12 characters</li>
                                <li [class.valid]="hasAtLeastThreeConditions()">✔ At least 3 of the following:
                                    <ul>
                                        <li [class.valid]="hasLowerCase()">Lower case letters (a-z)</li>
                                        <li [class.valid]="hasUpperCase()">Upper case letters (A-Z)</li>
                                        <li [class.valid]="hasNumber()">Numbers (0-9)</li>
                                        <li [class.valid]="hasSpecialChar()">Special characters (e.g. !&#64;#$%^&*)</li>
                                    </ul>
                                </li>
                                <li [class.valid]="hasNoTripleRepeat()">✔ No more than 2 identical characters in a
                                    row</li>
                            </ul>
                        </div>
                    </div>

                    <div class="form-row">
                        
                        <div class="form-group">
                            <app-text-input label="Dentist first name" [replaceDoubelQuotes]="true"
                                [for]="'Dentist First Name-Input'" [fieldType]="'firstName'"
                                [control]="signupForm.controls['dentistFirstName']" [maxLength]="50">
                            </app-text-input>
                        </div>
                        <div class="form-group">
                            <app-text-input label="Dentist last name" [replaceDoubelQuotes]="true"
                                [for]="'Dentist Last Name-Input'" [fieldType]="'lastName'"
                                [control]="signupForm.controls['dentistLastName']" [maxLength]="50">
                            </app-text-input>
                        </div>
                    </div>

                    <div class="form-row">
                        
                        <div class="form-group">
                            <app-select-input [for]="'LicenseState-select'" [label]="'License state'" [placeholder]="''"
                                [control]="signupForm.controls['licenseState']" [options]="licenseStateOptions"
                                (selectionChanged)="onLicenseStateChange($event)">
                            </app-select-input>
                        </div>
                        <div class="form-group">
                            <app-number-input id="LicenseInput" label="License number" [for]="'License Number-Input'"
                                (keypress)="restrictNonNumeric($event)" [control]="signupForm.controls['licenseNumber']"
                                [fieldType]="'License'" [errorMessages]="errormsg('licenseNumber')">
                            </app-number-input>
                        </div>
                        
                    </div>

                    <div class="form-row"
                        [ngClass]="{'cnfPassword': signupForm.get('licenseNumber')?.touched && signupForm.get('licenseNumber')?.errors?.['invalidRequirements']}">
                        <div class="form-group">
                            <app-number-input id="NpiInput" label="Individual NPI/TYP I number" [for]="'npi-Input'"
                                (keypress)="restrictNonNumeric($event)" [control]="signupForm.controls['npiNumber']"
                                [fieldType]="'NPI number'" [errorMessages]="errormsg('npiNumber')">
                            </app-number-input>
                        </div>
                        <div class="form-group">
                            <app-text-input [for]="'phone-number'" appPhoneMask [errorMessages]="errormessages"
                                [label]="'Phone'" [control]="signupForm.controls['phoneNumber']">
                            </app-text-input>
                        </div>
                    </div>

                    <div class="form-row">
                        
                    </div>

                    <div class="form-actions">
                        <div class="mainError" *ngIf="mainError">{{mainError}}</div>
                        <app-button [label]="'Create account'" id="Log in" [buttonType]="'primary'" [isFilled]="true"
                            (clicked)="onCreateAccount()" class="btn-create-account"
                            [ngClass]="{'disabledForm': signupForm.invalid}">
                        </app-button>

                        <div class="login-box-outer-gray">Already have an account?
                            <a href="" (click)="onSignIn(); $event.preventDefault()" class="register-link">
                                <strong>Sign in</strong>
                            </a>
                        </div>
                    </div>
                </form>
            </div>

            <div *ngIf="registrationSuccess" class="success-container">
                <img src="assets/images/greenlogo.svg" alt="Delta Dental Logo" class="success-logo">
                <h2>Thank you for registering.</h2>
                <div class="success-body">
                    <p>Please check for an email from <strong>{{registeredEmail}}</strong> and verify your account.</p>
                    <p>Once verified, you can log in.</p>
                </div>
                <app-button [label]="'Go to Sign In'" [buttonType]="'primary'"
                    (clicked)="logInWithAuth0()"></app-button>
            </div>
        </div>
    </div>
</div>
<app-footer-layout></app-footer-layout>